import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addOnsTitle: {
    defaultMessage: 'Add-Ons',
    id: 'jF2RFb',
    description: 'Title for the collapsible area where users can view and manage add-ons associated with their selected plan.',
  },
  addOnsDescription: {
    defaultMessage:
      'Add-Ons help you get more out of your ShipStation subscription and start shipping Smarter. Below are the Add-ons that have been activated for your account. To see all available Add-Ons go to Settings > Add-Ons.',
    id: 'dnMT/L',
    description: 'Description for the collapsible area where users can view and manage add-ons associated with their selected plan.',
  },
  deactivationDate: {
    description: 'the date the add-on will deactivate',
    defaultMessage: 'Deactivates on {deactivationDt}',
    id: '4dJg/G',
  },
  deactivate: {
    description: 'CTA that opens the add-on deactivation modal',
    defaultMessage: 'Deactivate',
    id: '4SoddB',
  },
  reactivate: {
    defaultMessage: 'Reactivate',
    id: 'V/n4EV',
    description: 'CTA to allow the user to reactivate an Add-On that is going to deactivate soon',
  },
  includedWithYourCurrentPlan: {
    defaultMessage: 'Included',
    id: 'cDJLIQ',
    description: 'Badge to display if the add-on is already included with your current plan',
  },
  manage: {
    defaultMessage: 'Manage',
    id: '2msWrO',
    description: 'CTA to allow the user to manage settings associated with an Add-On that has configuration',
  },
  noActiveAddOnsHeader: {
    description: 'header displayed when NONE of the Add-Ons available to the Seller are active',
    defaultMessage: 'No Add-Ons activated yet!',
    id: 'Mps7vp',
  },
  noActiveAddOnsDescription: {
    description: 'description displayed under the header when NONE of the Add-Ons available to the Seller are active',
    defaultMessage:
      "Add-ons extend ShipStation's capabilities to accommodate specialized workflows. To see all available add-ons go to Settings > Add-Ons.",
    id: 'pzRPOb',
  },
  price: {
    description: 'column header for the Add-On price',
    defaultMessage: 'Price',
    id: 'XX17Vm',
  },
  addOn: {
    description: 'column header for the Add-On name',
    defaultMessage: 'Add-On',
    id: 'ikung6',
  },
  description: {
    description: 'column header for the Add-On description',
    defaultMessage: 'Description',
    id: 'kNTbkE',
  },
  addOnNameWithTrial: {
    description: 'Badge to display if the add-on is being trialed',
    defaultMessage: '{addOnName} (Trial)',
    id: 'N+4aJS',
  },
  moreRemaining: {
    defaultMessage: '+{remaining} more',
    id: 'qBtc1r',
    description: 'Add ons subtitle',
  },
});
